import React, { FC } from 'react'

import { Icon4gPlusPlusProps } from './Icon4gPlusPlus.types'
import * as Styled from './styles/Icon4gPlusPlus.style'

import { nonThemeableRules } from '../../ruleSet'

const Icon4gPlusPlus: FC<Icon4gPlusPlusProps> = ({
  size = nonThemeableRules.defaultSize as number as Icon4gPlusPlusProps['size'],
  isResponsive = false,
}: Icon4gPlusPlusProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M22.707 24.275h3.043v2.6a2.072 2.072 0 0 1-1.518 2.058c-1.792.5-5.417.807-5.417-5.09 0-6.393 5.75-5.613 6.61-4m-11.167-.925V29.3m1.734-3.033H8.625l5.633-7.35M28.5 24h4m-2-2v4m4.975-2h4m-2-2v4'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19Z'
          stroke='#fff'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default Icon4gPlusPlus
